import {Accordion, AccordionSummary, AccordionDetails} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function ExpansionPanelStyled(props) {
  const label = props.label;
  const expanded = props.defaultExpanded;
  const backgroundColor = props.backgroundColor;
  const foreColor = props.foreColor;
  return <Accordion defaultExpanded={expanded} >
    <AccordionSummary
      aria-controls="panel1a-content"
      expandIcon={<AddIcon sx={{color: foreColor}} />}
      id={label}
      sx={{fontWeight: "600", background: backgroundColor, flexDirection: "row-reverse"}}
    >
      {label}
    </AccordionSummary>
    <AccordionDetails>
      {props.children}
    </AccordionDetails>
  </Accordion>;
}

export default ExpansionPanelStyled;
